// @ts-nocheck
import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import BaseAction, { BaseTypes } from "redux/actions/baseAction";
import i18n from 'i18next';

const defaultToastOptions = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  type: toast.TYPE.ERROR,
  draggable: true,
  progress: undefined,
  theme: 'colored',
  toastId: 'toast-notification'
};

export function toastMessageHandle(content, typeOption): any {
  toast[typeOption](content, {
    ...defaultToastOptions,
    type: typeOption,
  });
}

export function errorHandling(action: any): any {
  const { loggingData } = action;
  const matched = loggingData.message.match(/^(?<code>[A-Z_]+)\s/);
  const errorCode = matched?.groups?.code ?? '';
  const message = i18n.t(`errorMessages:${errorCode}`, { defaultValue: loggingData.message });
  toastMessageHandle(message, toast.TYPE.ERROR);
}

export function showToastMsg(action: any): any {
  const { content, typeOption } = action;
  toastMessageHandle(content, typeOption);
}

export function* setCurrentUser(action: any): any {
  try {
    yield put(BaseAction.setCurrentUserSuccess(action.currentUser));
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `SET_CURRENT_USER ${error}`
    }));
  }
}

export const watchBase = [
  takeLatest(BaseTypes.ERROR_HANDLING, errorHandling),
  takeLatest(BaseTypes.SHOW_TOAST_MSG, showToastMsg),
  takeLatest(BaseTypes.SET_CURRENT_USER, setCurrentUser),
]
